interface JurisdictionBadgeProps {
  jurisdiction: "TX" | "NM"
  formType?: "w3" | "sundry" | "w3a" | "c103"
  size?: "sm" | "md"
}

const FORM_LABELS: Record<string, string> = {
  w3: "W-3",
  sundry: "Sundry",
  w3a: "W-3A",
  c103: "C-103",
}

export default function JurisdictionBadge({
  jurisdiction,
  formType,
  size = "sm",
}: JurisdictionBadgeProps) {
  const label = formType ? `${jurisdiction} — ${FORM_LABELS[formType] ?? formType.toUpperCase()}` : jurisdiction

  const colorClass =
    jurisdiction === "NM"
      ? "bg-teal-50 text-teal-700 dark:bg-teal-500/15 dark:text-teal-400"
      : "bg-blue-50 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400"

  const sizeClass = size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-2.5 py-1"

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${sizeClass} ${colorClass}`}
    >
      {label}
    </span>
  )
}

/**
 * Derive jurisdiction from an API number string.
 * API numbers starting with "30" (New Mexico state code) are NM wells; all others default to TX.
 */
export function jurisdictionFromApiNumber(apiNumber: string): "TX" | "NM" {
  const digits = apiNumber.replace(/\D/g, "")
  return digits.startsWith("30") ? "NM" : "TX"
}
